// 淹没分析
import * as Cesium from 'cesium'
import yan from '@/assets/json/revier/yan.json'
import waterNormals from "@/assets/waterNormals.jpg";



export default class SubmergenceAnalysis {


    constructor(viewer, isTerrain = true, height_max, height_min, speed, map_type, scenario = null) {

        // let coordinates = yan.features[0].geometry.coordinates[0]
        //
        // let coordinateArray = [];
        //
        // for (let i = 0; i < coordinates.length; i++) {
        //     coordinateArray.push(coordinates[i][0]);
        //     coordinateArray.push(coordinates[i][1]);
        // }

        // let coordinateArray = [
        //     110.429428, 36.199773,
        //     110.46144, 36.198617,
        //     110.449154, 36.150535,
        //     110.426819, 36.151044,
        // ]


        let coordinateArray = [
            110.3426, 35.499107,
            110.341842, 35.501242,
            110.347304, 35.503249,
            110.347928, 35.500973,
        ]


        this.viewer = viewer
        this.isTerrain = isTerrain
        this.handler = null
        this.tempEntities = []
        this.polygonEntities = []
        this.extrudedHeight = height_min
        this.height_max = height_max
        this.height_min = height_min
        this.speed = speed
        // 默认是范围图
        this.map_type = map_type
        this.scenario = scenario
        this.frameIndex = 0
        this.frames = scenario && Array.isArray(scenario.frames) ? scenario.frames : []
        this.polygon_degrees = this.frames.length && this.frames[0].polygon
            ? this._flattenPolygon(this.frames[0].polygon)
            : coordinateArray

        this._initViewStatus(this.viewer)
    }
    _flattenPolygon(polygon) {
        const degrees = []
        polygon.forEach(point => {
            degrees.push(point[0])
            degrees.push(point[1])
        })
        return degrees
    }

    _initViewStatus(viewer) {
        var scene = viewer.scene
        // scene.globe.depthTestAgainstTerrain = true
        // scene.camera.setView({
        //     // 摄像头的位置
        //     destination: Cesium.Cartesian3.fromDegrees(110.445211, 36.144669, 806.9811352949284),
        //     orientation: {
        //         heading: 6.021159915725223,
        //         pitch: -0.19482638917497752,
        //         roll: 6.282340946874166
        //     }
        // });

        scene.camera.flyTo({
            // 摄像头的位置
            destination: Cesium.Cartesian3.fromDegrees(110.352214, 35.503038, 630.1647044280788),
            orientation: {
                heading: 4.309753365050971,
                pitch: -0.18985055881264024,
                roll:6.280214189434832
            }
        });
        viewer.skyAtmosphere = false
    }

    _drawPoly(degrees) {

        const that = this

        var imgMaterial = new Cesium.ImageMaterialProperty({
            image: waterNormals,
            repeat: new Cesium.Cartesian2(4, 4),
            color: new Cesium.Color(37/ 255.0, 158/255.0, 101/255.0, 0.7),
        });

        let entity =
            this.viewer.entities.add({
                polygon: {
                    hierarchy: {},
                    material: imgMaterial,
                    perPositionHeight: true,

                }
            })
        entity.polygon.hierarchy = new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(degrees))
        entity.polygon.extrudedHeight = new Cesium.CallbackProperty(() => that.extrudedHeight, false)
        this.polygonEntities.push(entity)
    }


    //移除整个资源
    remove() {
        let viewer = this.viewer
        for (let tempEntity of this.tempEntities) {
            viewer.entities.remove(tempEntity)
        }
        for (let lineEntity of this.polygonEntities) {
            viewer.entities.remove(lineEntity)
        }
        this.handler.destroy()
    }
    start() {
        const that = this
        this.timer = window.setInterval(() => {
            if (that.frames.length) {
                const frame = that.frames[that.frameIndex % that.frames.length]
                that.extrudedHeight = frame.stage
                that.frameIndex += 1
            } else if ((that.height_max > that.extrudedHeight) && (that.extrudedHeight >= that.height_min)) {
                that.extrudedHeight = that.extrudedHeight + that.speed
            } else {
                that.extrudedHeight = that.height_min
            }
        }, 500)
        if (that.map_type) {

            that._drawPoly(that.polygon_degrees)
        }

    }
    clear() {
        let viewer = this.viewer
        if (this.timer) {
            window.clearInterval(this.timer)
            this.timer = null
        }
        this.extrudedHeight = this.height_min;

        for (let entity of this.polygonEntities) {
            viewer.entities.remove(entity)
        }
        viewer.skyAtmosphere = true
    }

}
